import { Box, CardActionArea, CardMedia, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionAreaStyled = styled(CardActionArea)({
  cursor: 'pointer',
});

export const MediaStyled = styled(CardMedia)({
  backgroundColor: '#F2F2F2',
  color: '#D7D7E5',
  height: '12em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
// TODO: verificar pq tinha o mesmo style para div e CardMedia
export const MediaDivStyled = styled('div')({
  backgroundColor: '#F2F2F2',
  color: '#D7D7E5',
  height: '12em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StatusStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '65%',
  top: 0,
  borderRadius: '0 6px',
  backgroundColor: 'red',
  padding: 8,
  width: '40%',
  color: theme.palette.grey[900],
  letterSpacing: '2px',
}));

export const ConstructionNameStyled = styled(Typography)({
  fontSize: '0.8rem',
  fontWeight: 600,
  '@media(max-width: 1100px) and (min-width: 750px)': {
    fontSize: '0.7rem',
  },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
});
